import { render, staticRenderFns } from "./product_list_model.vue?vue&type=template&id=4dfb3d0f&scoped=true&"
import script from "../assets/js/product_list_model.js?vue&type=script&lang=js&"
export * from "../assets/js/product_list_model.js?vue&type=script&lang=js&"
import style0 from "./product_list_model.vue?vue&type=style&index=0&id=4dfb3d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb3d0f",
  null
  
)

export default component.exports